/***************************************************************************************
 * FileName      : EquipmentType.ts
 * Description   : 장비 유형 상수 및 타입 (JSON type 필드)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.10
 * Modified Date :
 * Reference     : packages/scjeil-smart_ict_lab-app/assets/json/equipment/*.json → type
 ***************************************************************************************/

// 2026.02.10 : 박은정 : 장비 유형 알려진 값 (확장 가능성 중간 → const + type)
// → 새 장비 유형 추가 시 여기에 값만 추가
export const EquipmentTypes = {
  HeatExchange: 'heat-exchange-system',
  Distillation: 'distillation-system',
  Circulation: 'circulation-system',
} as const;

export type EquipmentType = (typeof EquipmentTypes)[keyof typeof EquipmentTypes] | string;

